import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  getSolutionsBreadcrumbs,
  PageType,
  SolutionsHeroType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionHero } from 'routes/Solutions/components/SolutionHero'
import { SolutionHIL } from 'routes/Solutions/components/SolutionHIL'
import { SolutionHowItWorks } from 'routes/Solutions/components/SolutionHowItWorks'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import AppsGrid from '../components/SolutionHIL/components/AppsGrid'
import MonitorStatus from '../components/SolutionHIL/components/MonitorStatus'
import workflowBuilder1x from './workflow-builder@1x.avif'
import workflowBuilder2x from './workflow-builder@2x.avif'
import newWorkflow1x from './new-workflow@1x.png'
import newWorkflow2x from './new-workflow@2x.png'
import selectedData1x from './selected-data@1x.avif'
import selectedData2x from './selected-data@2x.avif'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'In-App Workflow Builder',
  href: LINKS.SOLUTIONS.IN_APP_WORKFLOW_BUILDER,
  imageSrc: `${workflowBuilder1x.src}`,
  srcSet: `${workflowBuilder1x.src} 1x, ${workflowBuilder2x.src} 2x`,
  description:
    'Let your users build custom automation / integration workflows right inside your app.',
}

const pageHeroData: SolutionsHeroType = {
  title: 'In-app workflow builder',
  subtitle:
    'Let your users build custom automation / integration workflows right inside your app.',
  subtitleAdditional:
    "It's like having Zapier embedded in your app, except you control the whole experience: how it looks, what steps are available, etc.",
  imageWidth: '453',
  imageHeight: '225',
  mobile1x: workflowBuilder1x,
  mobile2x: workflowBuilder2x,
  desktop1x: workflowBuilder1x,
  desktop2x: workflowBuilder2x,
  showAsRow: true,
}

export default function InAppWorkflowBuilder() {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <SolutionHero {...pageHeroData} />
        <SolutionHIL
          titles={[
            { text: 'Create a new workflow' },
            { text: 'Select app(s) to connect' },
            { text: 'Push selected data records or configure auto-push' },
            {
              text: 'Monitor pushes and react to errors',
              h64: true,
            },
          ]}
        >
          <img
            srcSet={`${newWorkflow1x.src} 1x, ${newWorkflow2x.src} 2x`}
            src={newWorkflow1x.src}
            alt='Create a new workflow'
            width={566}
            height={312}
            loading='lazy'
          />
          <AppsGrid />
          <img
            srcSet={`${selectedData1x.src} 1x, ${selectedData2x.src} 2x`}
            src={selectedData1x.src}
            alt='Push selected data records or configure auto-push'
            width={364}
            height={354}
            loading='lazy'
          />
          <MonitorStatus />
        </SolutionHIL>
        <SolutionHowItWorks
          steps={[
            'Select apps you want your customers to integrate with',
            'Select and configure actions / triggers',
            'Connect your front-end to integration.app to display the list of apps, triggers, and actions',
            'Connect your backend to subscribe to triggers and execute actions',
            'Optionally, connect logging and monitoring to your existing systems',
          ]}
        />
        <SolutionCompanies />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
